import Http from "@/api/http";

export default {
  // 登录
  check_login: params => {
    return Http.POST(
      "/login",
      null,
      {
        showCodeInPage: true,
      },
      params
    );
  },
  // 退出
  check_logout: () => {
    return Http.POST("/logout", null, {});
  },
};
